




























import { Product, Audit } from '@/models'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { ActionTypes } from '@/store/action-types'

@Component({
  components: {
    HistoricalChangesList: () => import('@/components/modals/HistoricalChangesList.vue')
  }
})
export default class ProductHistoricalModal extends Vue {
  @Prop({ required: true }) product: Product

  audits: Audit[] = []
  loading = false

  @Watch('product.id', { immediate: true })
  onProductChanged() {
    this.loadHistorical()
  }

  hideModal() {
    this.$bvModal.hide('productHistoricalModal')
  }

  private async loadHistorical() {
    this.audits = []
    if (this.product == null || this.product.id == null) {
      return
    }
    try {
      this.loading = true
      const response = await ApiClient.searchAudit(this.product.id, 'Product')
      this.audits = response
    } catch (e) {
      console.error(e)
      this.$store.dispatch(ActionTypes.SHOW_TOAST, {
        title: this.$t('feedback.error_title_generic'),
        variant: 'danger',
        message: this.$t('feedback.error_message_generic')
      })
    } finally {
      this.loading = false
    }
  }
}
